import i18n from '@/utils/i18n';
import React from 'react';
import { Banner, Button } from '@usepepper/sprout-kit-ui';
import { StyleProp, View, ViewStyle } from 'react-native';
import {
  useAgUiInterrupts,
  useAgUiSubmitInterruptResponses,
} from '@assistant-ui/react-ag-ui';

interface AgentApprovalBannersProps {
  style?: StyleProp<ViewStyle>;
}

export const AgentApprovalBanners: React.FC<AgentApprovalBannersProps> = ({
  style,
}) => {
  const interrupts = useAgUiInterrupts();
  const submit = useAgUiSubmitInterruptResponses();
  const respond = (id: string, approved: boolean) =>
    submit([{ interruptId: id, payload: { approved }, status: 'resolved' }]);

  return (
    <>
      {interrupts.map((interrupt) => (
        <View key={interrupt.id} style={style}>
          <Banner size="$md" tone="warning">
            <Banner.Title>
              {i18n.t('sales_portal.superintelligence.approval_title')}
            </Banner.Title>
            <Banner.Description>
              {interrupt.message ?? interrupt.toolCallId ?? interrupt.reason}
            </Banner.Description>
            <Banner.Actions>
              <Button
                onPress={() => void respond(interrupt.id, true)}
                size="$sm"
                variant="primary"
              >
                {i18n.t('sales_portal.superintelligence.approve')}
              </Button>
              <Button
                onPress={() => void respond(interrupt.id, false)}
                size="$sm"
                variant="secondary"
              >
                {i18n.t('sales_portal.superintelligence.deny')}
              </Button>
            </Banner.Actions>
          </Banner>
        </View>
      ))}
    </>
  );
};
